export default "__VITE_ASSET__xexWxLc3__"